import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import imgs from '../img/logo512.png';
export default function LeftSidebar({ isSidebarOpen, toggleSidebar }) {
    const location = useLocation();
    return (
        <>
            <ul className={isSidebarOpen ? 'navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled' : 'navbar-nav bg-gradient-primary sidebar sidebar-dark accordion'} id="accordionSidebar">
                <Link className="sidebar-brand d-flex align-items-center justify-content-center mt-3" to="/admin" >
                    <div className='row'>
                        <div className='col-md-10'>
                            <div className="sidebar-brand-text-img">
                                <img 
                        className="img-profile rounded-circle" 
                        src={imgs} 
                        alt="Profile"
                        style={{ height: '85px', width: '100px' }} 
                        />
                            </div>
                        </div>
                    </div>
                </Link>
                <hr className="sidebar-divider my-0" />
                <li className={`nav-item ${location.pathname === '/admin' ? 'active' : ''}`} >
                    <Link className="nav-link" to="/admin">
                        <i className="fas fa-fw fa-home"></i>
                        <span>Dashboard</span>
                    </Link>
                </li>
                
                
               
                <li className={`nav-item ${location.pathname === '/new-members' ? 'active' : ''}`} >
                    <Link className="nav-link" to="/new-members">
                        <i className="fas fa-fw fa-users"></i>
                        <span>New Registration</span>
                    </Link>
                </li>
                <li className={`nav-item ${location.pathname === '/members' ? 'active' : ''}`} >
                    <Link className="nav-link" to="/members">
                        <i className="fas fa-fw fa-user"></i>
                        <span>Registered Members</span>
                    </Link>
                </li>
               
                
              
               
                <hr className="sidebar-divider d-none d-md-block" />
                <div className="row">
                    <div className='col-md-12 d-flex justify-content-center '>
                        <div className="text-center d-none d-md-inline">
                            <button className="rounded-circle border-0" id="sidebarToggle" onClick={toggleSidebar}></button>
                        </div>
                    </div>
                </div>
            </ul>
        </>

    )
}
